// This function is speicifc for outputing the text into the reportDetails.tsx file
export const formatPiiDeleted = (text: string): JSX.Element => {
  // Define a regular expression to match "*Pii Deleted*"
  const regex = /\*PII Deleted\*/g;
  // Replace each occurrence of "*Pii Deleted*" with styled text
  const styledText = text.replace(regex, (match) => {
    // Return the styled text with <span> element containing inline styles
    return `<span style="color: red; font-style: italic;">${match}</span>`;
  });
  // Return the styled text with HTML tags
  return <div dangerouslySetInnerHTML={{ __html: styledText }} />;
};

// This function is specific for outputing the formatted text into the piiRemovalTextBox.tsx and RedactTextBox.tsx files
export const replacePiiDeleted = (text: string) => {
  // Define a regular expression to match "*Pii Deleted*"
  const regex = /\*PII Deleted\*/g;
  // Replace each occurrence of "*Pii Deleted*" with styled text
  const styledText = text.replace(regex, (match) => {
    // Return the styled text with <span> element containing inline styles
    return `<span style="color: red; font-style: italic;">${match}</span>`;
  });
  // Return the styled text with HTML tags
  return styledText;
};